import React, { useEffect } from "react"
import { Field, ErrorMessage, useFormikContext } from "formik"
import * as Yup from "yup"
import TextField from "@material-ui/core/TextField"
import InputLabel from "@material-ui/core/InputLabel"
import FormControl from "@material-ui/core/FormControl"
import Select from "@material-ui/core/Select"
import errorIcon from "images/error-icon.svg"
import { zipValidation, nameValidation, customFieldValidation } from "components/forms/validations"
import detector from "util/browser-detect"
import { stateOptions } from "components/forms/SharedInputs"
const FormikOnChangeComponent = (props) => {
  const { setFormStatus } = props;
  const formik = useFormikContext()
/*
  const isAnyFieldInvalid = (vals) => {
    let validForm = true;
    for (let prop in vals) {
      if (vals[prop]) {
        let value = vals[prop]
        if (value === "" || value === undefined || value === null) {
          validForm = false;
          break; //haha
        }
      }
      
    }
    return validForm;
  } */
    //const isFormIncomplete = Object.values(formik.values).some(value => value === "" || value === false || value === undefined)

  useEffect(() => {
    //let formValueStatus = isAnyFieldInvalid(formik.values)
    // console.log("changing form state", formik)
      if (formik.dirty === false || Object.keys(formik.errors).length > 0) {
        setFormStatus("is-invalid")
      }
      else {
        setFormStatus("is-valid")
      }

  }, [formik])

  return (<></>)
}

const POSTPayloadContructor = (stepFormData, values) => {
    // Our API needs the collection of confirmations sent to it in a collection (not as fields)
    let confirmations = {}
    stepFormData.confirmations.forEach(confirmationField => {
      if (values.hasOwnProperty(confirmationField.id)) {
        confirmations[confirmationField.id] = values[confirmationField.id]
      } else {
        confirmations[confirmationField.id] = false
      }
    })

    values["confirmations"] = confirmations
    return values;
}

const renderTextInput = props => {
  const errorExists = props.error || props.errors

  return (
    <FormControl className={`field field-${props.field.name}${props.index || ""}`} key={props.field.name}>
      <InputLabel htmlFor={`${props.field.name}-helper`}></InputLabel>
      <TextField
        error={props.error && props.touched && true}
        // helperText={props.error && props.touched && props.error} // this appears below the field
        label={props.label}
        type={props.type}
        value={props.field.value}
        variant="filled"
        name={props.field.name}
        id={`${props.field.name}-helper`}
        onChange={e => {
          props.form.setFieldValue(props.field.name, e.target.value)
        }}
      />
      {errorExists && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
      {errorExists && props.touched && <img className="error-icon" src={errorIcon} alt="" />}
    </FormControl>
  )
}
const zipInput = props => {
  const errorExists = props.error || props.errors
  return (
    <FormControl className={`field field-${props.field.name}${props.index || ""}`} key={props.field.name}>
      <InputLabel htmlFor={`${props.field.name}-helper`}></InputLabel>
      <TextField id={`${props.field.name}-helper`} error={props.error && props.form.isSubmitting && true} label={props.label} type={props.type} defaultValue={props.defaultValue} variant="filled" name={props.name} onChange={e => props.form.setFieldValue(props.field.name, e.target.value)} />
      {errorExists && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
      {errorExists && props.touched && <img className="error-icon" src={errorIcon} alt="" />}
    </FormControl>
  )
}
const renderSelectInput = props => {
  return (
    <FormControl variant="filled" className={`field field-${props.field.name}${props.index || ""}`} key={props.field.name}>
      <InputLabel htmlFor={`${props.field.name}-helper`}>{props.label}</InputLabel>
      <Select
        native
        label={props.label}
        value={props.field.value}
        variant="filled"
        onChange={e => {
          props.form.setFieldValue(props.field.name, e.target.value)
        }}
        inputProps={{
          name: props.name,
          id: `${props.field.name}-helper`,
        }}>
        <option aria-label="None" value="" key={-1} />
        {props.options.map((option, i) => {
          return (
            <option key={i} value={option.value}>
              {option.text}
            </option>
          )
        })}
      </Select>
      {props.error && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
    </FormControl>
  )
}

// leadgen fields are a fixed set of field "types"
const MAPPINGS = {
  firstName: {
    label: "First Name",
    type: "text",
    placeholder: "",
    required: true,
  },
  lastName: {
    label: "Last Name",
    type: "text",
    placeholder: "",
    required: true,
  },
  fullName: {
    label: "Full Name",
    type: "text",
    placeholder: "",
  },
  email: {
    label: "Email",
    type: "email",
    placeholder: "",
    required: true,
  },

  address: {
    label: "Address",
    type: "text",
    placeholder: "",
    required: true,
  },
  address2: {
    label: "Address 2",
    type: "text",
    placeholder: "",
  },
  city: {
    label: "City",
    type: "text",
    placeholder: "",
  },
  state: {
    label: "State",
    type: "state",
    placeholder: "",
    required: true,
  },
  zip: {
    label: "Zip Code",
    type: "zip",
    placeholder: "",
    required: true,
  },
  phoneNumber: {
    label: "Phone Number",
    type: "text",
    placeholder: "",
  },
  mobileNumber: {
    label: "Mobile Number",
    type: "text",
    placeholder: "",
  },
  birthday: {
    label: "Birthday",
    type: "date",
  },
  birthdayMonth: {
    label: "Birthday Month",
    type: "birthdayMonth",
  },
  birthdayDay: {
    label: "Birthday Day",
    type: "birthdayDay",
  },
  birthdayYear: {
    label: "Birthday Year",
    type: "birthdayYear",
  },

  largeText: {
    label: "Large Text",
    type: "text-box",
  },

  customText1: {
    label: "Custom Text 1",
    type: "text",
  },

  customText2: {
    label: "Custom Text 2",
    type: "text",
  },

  customText3: {
    label: "Custom Text 3",
    type: "text",
  },

  //Crazyass cat stuff
  newToBlue: {
    label: "Are you new to blue?",
    type: "select",
    required: true,
  },
  petGender: {
    label: "Pet's Gender",
    type: "select",
    required: true,
  },
  petName: {
    label: "Pet's Name",
    type: "text",
    placeholder: "",
    required: true,
  },
  petBirthDate: {
    label: "Pet's Birthday",
    type: "date",
    required: true,
  },
  // 'legal-user-acknowledgement-confirmation': {
  //     label: "*By clicking Submit I acknowledge that I have read and agree to be bound by the Dailybreak CP, LLC."
  // }
}

// render a Formik component for our leadgen field types
const getFieldByType = ({ field, formik, index }) => {
  let required = field.required || false;
  let requiredString = required ? "*" : "" //add an asterisk, but only if req'd

  
  if (field.name === "newToBlue") {
    return (
      <Field
        key={index}
        name="newToBlue"
        type="select"
        label={`Are you new to BLUE?*`}
        // placeholder={"Email"}
        component={renderSelectInput}
        options={[
          { value: true, text: "Yes, I just switched" },
          { value: false, text: "No, I’ve been feeding BLUE" },
        ]}
        error={formik.errors.newToBlue}
        touched={formik.touched.newToBlue && true}
      />
    )
  }
  if (field.name === "petGender") {
    return (
      <Field
        key={index}
        name="petGender"
        type="select"
        label={`${MAPPINGS[field.name].label}*`}
        // placeholder={"Email"}
        component={renderSelectInput}
        options={[
          { value: "M", text: "Male" },
          { value: "F", text: "Female" },
        ]}
        error={formik.errors.petGender}
        touched={formik.touched.petGender && true}
      />
    )
  }
  if (field.name === "petBirthDate") {
    const thisBrowser = detector().name
    if (thisBrowser === "Safari") {
      return (
        <Field
          key={index}
          name="petBirthDate"
          type="date"
          label={`Pet's Birthday*`}
          placeholder={"MM/DD/YYYY"}
          component={renderTextInput}
          error={formik.errors.petBirthDate}
          InputLabelProps={{
            shrink: true,
          }}
          touched={formik.touched.petBirthDate && true}
        />
      )
    } else {
      return (
        <Field
          key={index}
          name="petBirthDate"
          type="date"
          label={`Pet's Birthday*`}
          placeholder={"Pet Birthday"}
          component={renderTextInput}
          error={formik.errors[field.name]}
          touched={formik.touched.petBirthDate && true}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )
    }
  }



  if (field.name === "birthdayDay") {
    let options = []
    Array.from({ length: 31 }).forEach((_, i) => {
      options.push({ value: i + 1, text: i + 1 })
    })

    return (
      <Field
        key={index}
        name="birthdayDay"
        type="select"
        label={`${MAPPINGS[field.name].label}${requiredString}`}
        // placeholder={"Email"}
        component={renderSelectInput}
        options={options}
        // shrink={true}
        error={formik.errors.birthdayDay}
        touched={formik.touched.birthdayDay && true}
      />
    )
  }
  if (field.name === "zip" || field.name === "zipCode") {
    return <Field key={index} name="zipCode" label={`ZIP code${requiredString}`} error={formik.errors[field.name]} component={zipInput} variant="filled" touched={formik.touched[field.name] && true} />
  }
  if (field.name === "birthdayMonth") {
    let monthOptions = []
    monthOptions.push({ value: 1, text: "January" })
    monthOptions.push({ value: 2, text: "February" })
    monthOptions.push({ value: 3, text: "March" })
    monthOptions.push({ value: 4, text: "April" })
    monthOptions.push({ value: 5, text: "May" })
    monthOptions.push({ value: 6, text: "June" })
    monthOptions.push({ value: 7, text: "July" })
    monthOptions.push({ value: 8, text: "August" })
    monthOptions.push({ value: 9, text: "September" })
    monthOptions.push({ value: 10, text: "October" })
    monthOptions.push({ value: 11, text: "November" })
    monthOptions.push({ value: 12, text: "December" })

    return <Field key={index} name="birthdayMonth" type="select" label={`${MAPPINGS[field.name].label}${requiredString}`} component={renderSelectInput} options={monthOptions} error={formik.errors.birthdayMonth} touched={formik.touched.birthdayMonth && true} />
  }
  if (field.name === "birthdayYear") {
    let yearOptions = []
    for (let i = new Date().getFullYear(); i >= 1900; i--) {
      yearOptions.push({ value: i, text: i })
    }

    return <Field key={index} name="birthdayYear" type="select" label={`${MAPPINGS[field.name].label}${requiredString}`} component={renderSelectInput} options={yearOptions} error={formik.errors.birthdayYear} touched={formik.touched.birthdayYear && true} />
  }

  if (MAPPINGS[field.name] && MAPPINGS[field.name].type === "text") {

    let placeholder =  field.displayTitle || MAPPINGS[field.name].placeholder
    let label = field.displayTitle || MAPPINGS[field.name].label
    return <Field key={index} id={field.name} name={field.name} type="text" label={`${label}${requiredString}`} placeholder={placeholder} component={renderTextInput} error={formik.errors[field.name]} touched={formik.touched[field.name] && true} />
  }
  if (field.name === "state" || field.type === "state") {
    let stateLabel = field.displayTitle || MAPPINGS[field.name].label
    return (
      <>
    <Field name={"state"} key={index} type="text" label={`${stateLabel}${requiredString}`} variant="filled" component={renderSelectInput} options={stateOptions} error={formik.errors[field.name]} touched={formik.touched[field.name] && true} />
   
    
    </>
    )
  }
  if (field.name === "email") {
    return <Field key={index} id={field.name} name={field.name} type="email" component={renderTextInput} label={`${MAPPINGS[field.name].label}${requiredString}`} placeholder={"Email"} value={formik.values.email} errors={formik.errors.email} touched={formik.touched.email && true} />
  }

  

  return <p>unhandlsdgsgsded field type: {field.name}</p>
}


const generateInitialValues = (userProfile, step, isEmbed) => {
  if (userProfile && step) {
    let initialValues = {}
    step.leadGenForm.fields && step.leadGenForm.fields.forEach((field, i) => {
      initialValues[field.name] = ""
    })

    // try auto-filling some fields
    if (!isEmbed && initialValues.hasOwnProperty("firstName")) {
      initialValues["firstName"] = userProfile.guest ? "" : userProfile.firstName
    }

    if (!isEmbed && initialValues.hasOwnProperty("lastName")) {
      initialValues["lastName"] = userProfile.guest ? "" : userProfile.lastName
    }

    if (!isEmbed && initialValues.hasOwnProperty("email")) {
      initialValues["email"] = userProfile.guest ? "" : userProfile.username
    }
    step.leadGenForm.confirmations.forEach(field => {
      initialValues[field.id] = false
    })
    initialValues["leadId"] = step.leadGenForm.id
    return initialValues
  }
}


const formatSafariDate = str => {
  //this is quick and dirty, sorrynotsorry
  if (typeof str === "string") {
    try {
      let arrDelimiter = str.indexOf("-") > -1 ? "-" : "/"
      let arr = str.split(arrDelimiter)
      let isoStr = `${arr[2]}-${arr[0]}-${arr[1]}`
      let parsedDate = new Date(isoStr)

      return parsedDate
    } catch (e) {
      console.warn(`problem parsing date`)
    }
  }
}
const safariParse2 = function (str) {
  try {
    let arrDelimiter = str.indexOf("-") > -1 ? "-" : "/"
    let arr = str.split(arrDelimiter)
    let isoStr = `${arr[2]}-${arr[0]}-${arr[1]}`
    return isoStr
  } catch (e) {
    console.warn(`problem parsing date`)
  }
}
function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear()

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return [year, month, day].join("-")
}
const isADate = function (theVar) {
  let ret = false
  try {
    ret = typeof theVar.getMonth === "function"
  } catch (e) {}
  return ret
}

const generateFormValidation2 = (stepFormData) => {
 
  // since we have the same set of fields for leadgen we can use this same config for all steps
  // we could probably generate this based on our MAPPINGS map above
  const validationSchema = {
    zip: Yup.string()
      .matches(/^[0-9]{5}(?:-[0-9]{4})?$/, "Must be 5 or 9 digits")
      .required("Required field"),
    firstName: nameValidation,
    lastName: nameValidation,
    email: Yup.string().email("Invalid email address"),
    birthdayDay: Yup.number().min(1).max(31),
    birthdayMonth: Yup.number().min(1).max(12),
    birthdayYear: Yup.number().moreThan(1900),
    customText1: customFieldValidation,
    customText2: customFieldValidation,
    customText3: customFieldValidation,
    zipCode: zipValidation,
    state: Yup.string()
  }

  let yupSchema = {}
  stepFormData.fields && stepFormData.fields.forEach(function(field) {
    if (validationSchema[field.name]) {

      if (field) {
        if (field.required && field.required === true) {
          yupSchema[field.name] = validationSchema[field.name].required("Field is required")
        }
        else {
          yupSchema[field.name] = validationSchema[field.name]
        }
      } 
    }
  })
  let confirmationSchema = {}
  //Better way of doing checkbox validation. only some checkboxes are required. We need to slugify the field name or else named fields with spaces will freak js out.
  stepFormData.confirmations.forEach(obj => {
    if (obj.required) {
      confirmationSchema[obj.id] = Yup.bool().oneOf([true], "Required field")
    }
  })
  let finalSchema = {...confirmationSchema, ...yupSchema}
  return Yup.object(finalSchema)
}

/*
For campaigns for the nexxt client our client services team wants the lead gen form to post directly to nexxt. 

This renders a second form on the page that will be submitted after our form captures data

Nexxt systems have their own field names, so this maps them before submitting.
*/
const NexxtForm = React.forwardRef(({config, formik, extra={}}, ref) => {

  const nameMap = {
    firstName: "FFirstName",
    lastName: "FLastName",
    email: "FEAdd",
    zipCode: "FZipCode",
    customText1: "FTitle",
    customText2: "FCareerFocus1"

  }

  if (extra === null) {
    extra = {}
  }

  return (
    <>
      <form ref={ref} action="https://www.nexxt.com/js/action/signupfree.asp" method="POST" target="_parent">
        { config.fields && config.fields.map((field, i) => {
          return (
            <input key={i} type="hidden" name={nameMap[field.name]} value={formik.values[field.name]} />
          )
        })}
        { Object.entries(extra).map(([key, value], i) => {

          return (
            <input key={i + "j"} type="hidden" name={key} value={value} />
          )        
        })}
      </form>
    </>
  )
})


export { renderTextInput, getFieldByType, MAPPINGS, renderSelectInput, generateInitialValues, POSTPayloadContructor, FormikOnChangeComponent, generateFormValidation2, NexxtForm}
